/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DailyOrgSummaryUsageResponse { 
    /**
     * Timestamp in UTC when the interval was inserted in table
     */
    created_ts?: Date;
    /**
     * CSP service type value.
     */
    csp_service_type?: string;
    /**
     * max rwr cb protected vm count on usage_date
     */
    max_rwr_cb_vm_count?: number;
    /**
     * max rwr cs protected vm count on usage_date
     */
    max_rwr_cs_vm_count?: number;
    /**
     * actual max tibs used for AP datacenter on usage_date
     */
    max_tib_usage_ap?: number;
    /**
     * actual max tibs used for EM datacenter on usage_date
     */
    max_tib_usage_em?: number;
    /**
     * actual max tibs used for LT datacenter on usage_date
     */
    max_tib_usage_lt?: number;
    /**
     * actual max tibs used for US datacenter on usage_date
     */
    max_tib_usage_us?: number;
    /**
     * actual max vm usage on usage_date across datacenters
     */
    max_vm_usage?: number;
    org_id?: string;
    /**
     * reported max tibs used for AP datacenter on usage_date
     */
    overage_tib_usage_ap?: number;
    /**
     * reported max tibs used for EM datacenter on usage_date
     */
    overage_tib_usage_em?: number;
    /**
     * reported max tibs used for LT datacenter on usage_date
     */
    overage_tib_usage_lt?: number;
    /**
     * reported max tibs used for US datacenter on usage_date
     */
    overage_tib_usage_us?: number;
    /**
     * reported max vm usage on usage_date
     */
    overage_vm_usage?: number;
    /**
     * tib subscription quantity for AP on usage_date
     */
    tib_subscription_ap?: number;
    /**
     * tib subscription quantity for EM on usage_date
     */
    tib_subscription_em?: number;
    /**
     * tib subscription quantity for LT on usage_date
     */
    tib_subscription_lt?: number;
    /**
     * tib subscription quantity for US on usage_date
     */
    tib_subscription_us?: number;
    /**
     * Timestamp in UTC when the interval was updated in table
     */
    updated_ts?: Date;
    /**
     * Date of the usage in YYYY-MM-DD.
     */
    usage_date?: string;
    /**
     * vm subscription quantity on usage_date
     */
    vm_subscription_quantity?: number;
}

